import { Directive, ElementRef, Input, OnDestroy, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonUtilsService } from './../services/common-utils.service';

@Directive({
  selector: '[bpDisplayIfKeyboardIsClosed]',
  standalone: false
})
export class DisplayIfKeyboardIsClosedDirective implements OnDestroy {
  private el = inject(ElementRef);
  private utils = inject(CommonUtilsService);

  private subscription: Subscription;
  private initialDisplayValue: string;

  @Input('bpDisplayIfKeyboardIsClosed') set display(v: boolean) {
    this.subscription = this.utils.keyboardOpened$.subscribe(closed => {
      if (v === false) {
        this.el.nativeElement.style.display = closed
          ? this.initialDisplayValue
          : 'none';
      } else {
        this.el.nativeElement.style.display = closed
          ? 'none'
          : this.initialDisplayValue;
      }
    });
  }

  constructor() {
    this.initialDisplayValue = this.el.nativeElement.style.display;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
